export interface MarketingNavItem {
  label: string;
  /** Internal app route. */
  to?: "/pricing" | "/support";
  /** Same-site anchor or external destination. */
  href?: string;
}

/** One information architecture for the logged-out header and mobile rail. */
export const MARKETING_NAV: readonly MarketingNavItem[] = [
  { label: "Pricing", to: "/pricing" },
  { label: "How it works", href: "/#how-it-works" },
  { label: "Documentation", href: "https://docs.sylviq.io/docs" },
  { label: "Support", to: "/support" },
];

export const MARKETING_LOGIN_PATH = "/login";
export const MARKETING_SIGNUP_PATH = "/signup";
